import { ChangeDetectionStrategy, Component, ViewEncapsulation } from "@angular/core";
import { ModalComponent } from "../modal.component";

@Component({
    template: `
        <s25-modal-header [data]="data"></s25-modal-header>
        <div class="modal-body ngCenter">
            <div class="ngCenter ngS25ModalDialogMsg" [innerHTML]="data.message | safeHTML"></div>
            <div class="ngCenter ngS25ModalDialogBtn">
                <button (click)="data?.closeModal?.()" class="aw-button aw-button--outline">OK</button>
            </div>
        </div>
    `,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ModalAlertComponent extends ModalComponent<{ message: string }> {}
